import {createContext, ReactNode} from 'react';
import Environment from "../services/interfaces/Environment";

export interface EnvironmentProviderProps {
    children: ReactNode,
    env: Environment
}

export const EnvironmentContext = createContext<Environment | undefined>(undefined);

export const EnvironmentProvider = ({ children, env }: EnvironmentProviderProps) => {
    return (
        <EnvironmentContext.Provider value={env}>
            {children}
        </EnvironmentContext.Provider>
    );
};